import { render } from "./BuyAdModal.vue?vue&type=template&id=ada82de0"
import script from "./BuyAdModal.vue?vue&type=script&lang=js"
export * from "./BuyAdModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__